import React, { Component, Fragment } from 'react';
import { Menu } from 'antd';
import { Link, Route, Switch } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import LoadingScreen from 'react-loading-screen';
import { StatusPanel } from './StatusPanel';
import { TradeView } from './TradeView';

@inject('store')
@observer
export class MakoBotView extends Component {
    async componentDidMount() {
        await this.props.store.makoBotStore.getConfig(this.props.match.params.id);
        this.props.store.makoBotStore.connectToStream(this.props.match.params.id);
        this.props.store.makoBotStore.getPositions(this.props.match.params.id);
        this.props.store.makoBotStore.getPerformance(this.props.match.params.id);
    }

    componentWillUpdate(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.props.store.makoBotStore.getConfig(nextProps.match.params.id).then(() => {
                this.props.store.makoBotStore.connectToStream(nextProps.match.params.id);
                this.props.store.makoBotStore.getPositions(nextProps.match.params.id);
                this.props.store.makoBotStore.getPerformance(nextProps.match.params.id);
            });
            this.props.store.makoBotStore.closeStream(this.props.match.params.id);
        }
    }

    render() {
        const botId = this.props.match.params.id;
        const { config } = this.props.store.makoBotStore;

        if (!config) {
            return (
                <LoadingScreen
                    loading={true}
                    bgColor="#f1f1f1"
                    logoSrc={'/logo.png'}
                    text={'Loading trading terminal'}
                >
                    <span />
                </LoadingScreen>
            );
        }

        return (
            <Fragment>
                <StatusPanel />

                <Switch>
                    <Route exact path="/a/mako/:id/trade" component={TradeView} />
                </Switch>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/index.js